/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconLike = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <path
        fill="currentColor"
        d="M24 11.034a2.5 2.5 0 0 0-2.5-2.5h-6.311a.249.249 0 0 1-.237-.328 8.688 8.688 0 0 0 .52-4.407c-.588-2.1-1.834-2.7-2.808-2.565A2 2 0 0 0 11 3.284c0 2.746-2.129 5.746-4.034 7.061a.5.5 0 0 0-.216.412v10.116a.5.5 0 0 0 .405.491c.357.068.681.135.987.2a17.38 17.38 0 0 0 4.108.471h6.5c1.958 0 2.25-1.1 2.25-1.75 0-.345-.079-.685-.231-.995a2.251 2.251 0 0 0 1-3 2.25 2.25 0 0 0 .959-3.078A2.5 2.5 0 0 0 24 11.034zm-18.75-.25a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3.25a1 1 0 0 0 1-1v-11zm-1.5 9.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0z"
      />
    </svg>
  ),
);
